/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiParameter,
    doesNotHaveExpand,
    get,
    HasPagingParameters,
} from "@insite/client-framework/Services/ApiService";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

export interface GetOrdersApiParameter extends ApiParameter, HasPagingParameters {
    orderNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    orderTotalOperator?: string;
    orderTotal?: number;
    productErpNumber?: string;
    sort?: string;
    orderedBy?: string;
    isOrdersPage?: boolean;
    orderType?: string;
}

const ordersUrl = "/api/v1/orders";

export async function getOrders(parameter: GetOrdersApiParameter): Promise<OrderCollectionModel> {
    // can't send empty status array to API
    if (parameter.status && parameter.status.length === 0) {
        delete parameter.status;
    }

    const orders = await get<OrderCollectionModel>(ordersUrl, parameter);
    orders.orders?.forEach(o => {
        cleanOrder(o);
    });
    return orders;
}

function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);

    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }
}
